import React from "react";
import Productcard from "./productcard";

const Productsfour = ({ products, showquantity, showoffer }) => {

    return (
        <div className='wrapfourcards'>
            {products?.slice(0, 4).map((val, key) => {
                return (
                    <Productcard product={val} key={key} showoffer={showoffer} showquantity={showquantity} alignmiddle={true} />
                )
            })}
        </div>
    );
}

export default Productsfour;